import applyMine from '../../views/insurance/apply-mine.vue';
import policyDetail from '../../views/insurance/policy-detail.vue';
import sureView from '../../views/insurance/apply-loan-sure.vue';
import applyLoanSuccess from '../../views/insurance/apply-loan-success.vue';
import applyLoan from '../../views/insurance/apply-loan.vue';
var insurance = [
    {
        name: 'applyMine',
        path: 'apply-mine',
        component: applyMine,
    },
    {
        name: 'policyDetail',
        path: 'apply-mine/policyDetail',
        component: policyDetail,
    },
    {
        name: 'applyLoanSure',
        path: 'apply-loan/sure',
        component: sureView,
    },
    {
        name: 'applyLoanSuccess',
        path: 'apply-loan-success',
        component: applyLoanSuccess,
    },
    {
        name: 'applyLoan',
        path: 'apply-loan',
        component: applyLoan,
    },
];
export default insurance;
